export default {
    activateuser: {
        headerLabel: '사용자 온보딩',
        accountActivation: '계정 활성화',
        step1: {
            header: '플랫폼에 오신 것을 환영합니다!',
            subHeader: '계정에 연결할 방법을 선택하십시오.',
            description:
                '더 간단한 로그인 프로세스를 위해 계정을 다음 서비스 중 하나 이상에 연결하는 것이 좋습니다.',
            OR: '아니면',
            emailAndPassword: '사용자 본인의 이메일 사용',
        },
        step2: {
            header: '이메일 및 비밀번호 사용',
            description:
                '이것이 당신의 계정에 연결될 주 이메일입니다. 졸업 후에도 데이터에 계속 액세스하려면 대학 이메일 주소와는 다른 이메일을 사용하는 것이 좋습니다. 계정 설정을 통해 당사로부터 어떤 이메일을 받을 것인지 쉽게 제어할 수 있습니다.',
            invalidEmail: '제공해주신 이메일은 유효한 이메일이 아닙니다.',
            passwordsNotMatch: '비밀번호가 일치해야 합니다.',
            passwordDescription01:
                '계정 보안을 유지하려면 새 비밀번호를 설정해야 합니다. 다음을 사용하여 비밀번호를 생성하십시오.',
            passwordDescription02: '최소 8자',
            passwordDescription03: '하나 이상의 소문자(a-z)',
            passwordDescription04: '하나 이상의 대문자(A-Z)',
            passwordDescription05: '하나 이상의 숫자 또는 특수 기호(0-9, !#$ 등)',
            passwordDescription06: '고유 문자 6자 이상',
            repeatPassword: '비밀번호 반복',
        },
        step3: {
            header: '사용자 활성화하기',
            loadingHints: {
                '0': '사용자 데이터 로드 중',
                '1': '모두 준비하기',
                '2': '당신을 기다리는 새로운 가능성',
                '3': '거의 다 했어요!',
            },
            successHeader: '이제 계정을 사용할 수 있습니다!',
            successSubheader: '이제 독점 기능에 액세스할 수 있습니다!',
            errorHeader: '계정을 활성화할 수 없었습니다.',
            ifWrongContact: '이 문제가 잘못되었다고 생각되면 지원팀에 문의하십시오.',
            contactForHelp: '도움이 필요한 연락처',
            goBack: '돌아가기',
        },
    },
    assessments: {
        general: {
            checkMyProgress: '진행 상태 확인',
            getStarted: '시작해보세요!',
            getToKnowYourself: '자신에 대해 알아가보세요.',
            getToKnowYourselfBold: '<strong>자신<strong>에 대해 알아가보세요.',
            getToKnowYourFuture: '당신의 미래에 대해 알아가보세요.',
            getToKnowYourFutureBold: '당신의 <strong>미래</strong>를 알아가보세요.',
            openAssessments: '공개 평가',
            openAssessment: '공개 평가',
            unlock: '테스트 잠금 해제',
            testYourself: '직접 테스트해보세요.',
            takeTheFreeTests: '무료 테스트 받기',
            youOwnThisProduct: '당신은 이 제품을 갖고 있습니다.',
            startTest: '테스트 시작',
            startTests: '테스트 시작',
            continue: '계속하세요',
            showReport: '보고서 표시',
            showYourReports: '당신의 보고서를 표시하세요.',
            showYourReport: '당신의 보고서를 표시하세요.',
            continueFreeTests: '무료 테스트 계속하기',
            continueTheTest: '테스트 계속하기',
            estimatedTime: '~ {min} 분',
        },
        landing: {
            section1: {
                title: '스스로 테스트해보기',
                description01:
                    '평가 센터에 오신 것을 환영합니다 - 여기서부터 커리어 여정이 시작됩니다.',
                description02:
                    '<strong>Aon 평가</strong>를 받을 수 있는 곳이 여기 있습니다. 전 세계 채용 담당자들이 사용하는 테스트를 통해 미래의 직업에 대한 적성과 준비 상태를 확인할 수 있습니다.',
                freemium: {
                    description:
                        '이 테스트를 통해 자신의 강점을 측정하고 기술에 대한 효율적인 보고서를 받아보세요.',
                    price: '무료',
                    numTests: '3개의 테스트',
                    timeEstimated: '약 27분',
                },
                premium: {
                    description:
                        '이게 <strong>진짜입니다</strong>. 이 3-in-1 테스트를 통해 어떤 커리어를 추구해야 하는지 알아보고 전체 후보 보고서를 받아보십시오.',
                    numTests: '3-in-1 테스트',
                    timeEstimated: '약 60분',
                    sampleReport: '↓샘플 보고서 작성',
                    candidateReport: '후보 보고서',
                    candidateReportDescription:
                        '이 테스트를 마치면 개인 기술 향상에 대한 팁, 주의해야 할 스킬, 시작할 수 있는 최상의 기회, 다음 단계는 무엇인지를 비롯한 결과에 대한 종합적인 개요가 포함된 전체 후보 보고서가 제공됩니다.',
                },
            },
            section2: {
                title: '이 시험들이 취업에 어떻게 도움이 될까요?',
                t1: '당신은 자신이 가진 <strong>스킬</strong>에 대해 알게 될 것입니다.',
                t2: '당신은 자신이 가진 <strong>잠재력</strong>에 대해 알게 될 것입니다.',
                t3: '당신은 확실한 <strong>커리어 패스</strong>를 갖게 될 것입니다.',
                t4: '당신은 자신의 <strong>자신감</strong>을 북돋워주게 될 것입니다.',
            },
            section3: {
                title:
                    '자신의 발전과 경력을 발전시킬 수 있는 개인적 장점과 경력 기회에 대해 알아봅니다.',
            },
            section4: {
                title: '오늘 바로 경쟁자들보다 더 앞서나가보세요.',
                description:
                    '딜로이트, 지멘스, 버거킹, 보다폰 또는 P&G와 같은 회사의 채용 담당자들이 사용하는 평가를 완료함으로써,',
            },
            section5: {
                title: '자주 묻는 질문',
                thisPage: '이 페이지',
                question01: {
                    q: 'Aon 평가란?',
                    a:
                        'Aon의 인재평가는 세계적으로 인정받는 시험으로 전 세계 기업들이 가장 적합한 직종 후보자를 가려내는 데 도움이 됩니다. 인재 평가의 도움으로 채용자들은 이력서, 내신 성적, 대학 자격증, 대학 졸업장을 외에도 해당 후보자 직무에 잘 어울리는지 알아볼 수 있게 되었습니다.\n<br><br>\n 이러한 솔루션은 대개 <strong>채용자 전용</strong>으로 예약되어 있습니다. 여기서는 면접 전에 연습 및 결과 획득을 위한 <strong>독점</strong> 기회를 제공합니다. 대부분의 지원자는 이런 기회를 얻지 못하므로, 이 기회를 활용해보십시오!',
                },
                question02: {
                    q: '이런 평가를 받으려면 돈을 지불해야 하나요?',
                    a:
                        '이 테스트 중 <i>업무 관련 행동</i>, <i>숫자 추론</i>, <i>유추적 논리적 사고</i> 및 <i>귀납적 논리 추론</i>의 4개의 평가를 무료로 응시할 수 있습니다. 이 테스트들은 당신의 기술과 적성을 측정하는 것이고 당신의 강점과 약점을 알아내는 좋은 방법이 되어줍니다.\n\n<br><br>그러나 자신의 성향에 대해 전체적으로 파악하고, 가장 적합한 진로에 대한 전문적인 통찰력을 얻고, 미래의 성공을 위해 큰 발걸음을 내딛고 싶다면, €79의 금액으로 종합 후보 보고서를 받아보실 수 있습니다. <br><br>확장 액세스를 원할 경우, 그저 <a href={premiumLink}>여기</a>만 눌러 카드로 지불해주세요 – 보안 결제 방법을 사용하고 있습니다.\n',
                },
                question03: { q: '제가 왜 이런 시험을 봐야 하나요?' },
                question04: {
                    q: '이 시험들을 어떻게 준비해야 하나요?',
                    a:
                        '기술적인 요구 사항과 평가에 대비하는 방법에 대한 모든 내용은 <a href={link} target="_blank">의 페이지</a>에서 확인할 수 있습니다. 해당 페이지에서 당신은 자신이 잘하는 뭔가를 찾을 수 있게 도와줄 자료들을 찾아볼 수 있을 겁니다',
                },
                question05: {
                    q: '이런 평가는 또 어디서 볼 수 있나요?',
                    a:
                        '일반적으로 채용 담당자에 의해 이러한 테스트를 완료하라는 요청을 받을 수 있습니다. 그 외에는 다른 곳에서는 이러한 테스트를 수행할 수 없습니다. 이것은 당신이 연습할 수 있는 독점적인 기회이며, 당신 자신에 대해 더 많이 알아보고, 미래의 직업에 대해 알아볼 수 있는 기회가 되어줄 것입니다.',
                },
                question06: {
                    q: '시험은 몇 번 칠 수 있나요?',
                    a:
                        '각 테스트마다 한 번씩만 응시할 수 있습니다. 재응시 금지! 이 기회를 최대한 활용하기 위해 편안한 환경을 갖춰주세요. 시험을 보기 전에 안내방송 영상을 보며 연습을 하다보면 익숙해질 수 있을 겁니다.',
                },
                question07: {
                    q: '이 시험들은 어느 나라 언어로 진행되나요?',
                    a:
                        '\n 이러한 테스트의 경우 기본 언어는 영어이지만 각 테스트에는 선택할 수 있는 다양한 언어들이 있습니다. 시험을 보기 전에 어떤 언어를 사용할 수 있는지 확인하고 자신에게 가장 적합한 언어를 선택할 수 있습니다. \n',
                },
                question08: {
                    q: '한번 결제하면 연장된 테스트에 유효기간이 있나요?',
                    a:
                        '아니요! 결제 후 언제든지 연장 시험을 보실 수 있습니다. 시간을 내어 가장 적합한 시간에 평가를 준비하고 시작해보세요.',
                },
            },
        },
        center: {
            banner: {
                title: '진행 상황 확인',
                subtitle: '다음은 경력 평가의 진행 상황에 대한 개요입니다.',
                moreInfo: '추가 정보',
                yourProgress: '진행 상황',
                quote:
                    '목표를 설정하는 것은 보이지 않는 것을 보이는 것으로 바꾸기 위한 첫 번째 단계에 해당합니다.',
            },
            list: {
                timeEstimated: '대략 {minutes} 분',
                freemium: {
                    intro:
                        '\n 이건 개인적인 개발을 위한 여정의 첫 단계입니다! <br/>\n 이 테스트를 통해 자신의 장점을 알아보고 자신의 능력에 대한 효과적인 보고서를 받아보세요.\n',
                },
                premium: {
                    intro:
                        '\n 이제부터가 진짜예요.<br />\n 다음 테스트를 통해 어떤 진로를 추구해야 하는지 알아보고\n 포괄적인 <strong>후보 보고서</strong>를 받아보십시오.\n',
                    description:
                        '\n 당신의 <strong>후보 보고서</strong>에서는 당신의\n 개인 능력 향상, 어떤 <strong>능력</strong>에 주의를 집중해야 하는지, 시작할 수 있는\n 최고의 <strong>기회</strong> 및 당신이\n <strong>다음으로 취해야 할 단계</strong>는 무엇인지 등등에 대한 <strong>팁</strong>을 비롯하여 당신의 결과에 대한 종합적인\n 개요를 제공합니다.\n',
                },
            },
            instruments: {
                '344': {
                    name: '연역-논리적 사고',
                    description:
                        '이 테스트는 분석 및 문제 해결 능력을 측정하는 지식 사용 및 규칙 적용을 얼마나 잘하는지 확인합니다.',
                    estimatedTime: '9',
                },
                '383': {
                    name: '귀납-논리 추론',
                    description:
                        '규칙과 상호관계를 얼마나 잘 식별할 수 있습니까? 당신의 분석력과 문제 해결 능력을 측정해주는 이 테스트를 통해 확인해보세요.',
                    estimatedTime: '9',
                },
                '390': {
                    name: '업무 관련 행동',
                    description:
                        '직원으로서 당신의 성격 특징은 무엇입니까? 자신의 업무에 기반한 성격 특성을 파악해주는 이 테스트를 통해 확인해보세요.',
                    estimatedTime: '30',
                },
                '721': {
                    name: '수치 추론',
                    description:
                        '숫자에 강한 편입니까? 이 테스트는 수치 정보에 대한 이해와 논리적 결론 도달 여부를 측정합니다.',
                    estimatedTime: '9',
                },
                '5392': {
                    name: '작업 메모리',
                    description:
                        '얼마나 집중력을 유지할 수 있습니까? 이 테스트는 산만한 환경에서 정보를 처리하고 기억하는 능력을 측정합니다.',
                    estimatedTime: '15',
                },
                '82013': {
                    name: '플렉스 테스트 (flexTest)',
                    description:
                        '당신의 관심사는 무엇입니까? 이 설문지를 통해 원하는 진로를 결정할 수 있습니다.',
                    estimatedTime: '15',
                },
            },
        },
        dialog: {
            header: 'Aon 평가 시작',
            consent:
                '저는 Aon이 본 평가와 관련된 제 데이터에 책임이 있다는 것을 알고 있으며, Aon의 약관에 동의합니다.\n 또한 Higherd 측에서 보고서를 생성하기 위해 제 이름을 Aon으로 이전할 수 있다는 데 동의합니다.',
            startTest: '테스트 시작',
            consentErrorTitle: '동의오류',
            consentErrorMessage: '동의서를 제출하는 동안 문제가 발생했습니다. 이메일 확인하셨나요?',
        },
    },
    "<br><br>\\n           Premier - vous arrivez préparé avec une partie du processus de recrutement déjà effectuée, ce qui vous fera instantanément prendre de l'avance sur les autres candidats": {
        '\\n            <br><br>\\n Deuxième - vous abordez votre recrutement avec un esprit clair': {
            " Vous connaissez vos points forts et ce que l'avenir vous réserve - motivation instantanée et véritable regain de confiance garantis! Les recruteurs pourront le dire": {
                '"':
                    '\\ n Рекрутеры по всему миру используют оценочные тесты AON в процессе отбора кандидатов. Заполнив их заранее и предоставив готовые отчеты, вы получите прекрасную возможность по-настоящему поразить рекрутеров. Как? \\ n <br> <br> \\ n Во-первых, вы подготовились к тому, что часть процесса набора уже завершена, что мгновенно заставит вас опередить других кандидатов. \\ n <br> <br> \\ n Во-вторых, вы приближаетесь к своему набор с ясным умом. Вы знаете свои сильные стороны и свое будущее - мгновенная мотивация и должное повышение уверенности гарантированы! Рекрутеры смогут это сказать.',
            },
        },
    },
    calendar: {
        header: '달력',
        myCalendar: '내 달력',
        noCalendar: '당신의 경력 서비스에서 아직 달력 기능이 활성화 되지 않았습니다.',
        goBackBtn: '돌아가기',
        calendarNotReady: '내 일정 기능이 아직 준비되지 않았습니다. 곧 됩니다!',
        noUpcomingAppointments: '예정된 약속이 없습니다.',
        appointmentMissing: '약속이 활성 상태가 아닙니다.',
        appointmentNotActive:
            '죄송하지만, 당신은 지금 존재하지 않거나 활성 상태가 아닌 약속을 보려 하고 있습니다.',
        appointmentNotHavingAvailability:
            '죄송합니다, 이 약속은 현재 취소되었습니다. 나중에 다시 확인해 보세요.',
        appointmentMissingRules: '약속을 이용할 수 없습니다',
        needToCompleteProfile: '프로필을 완성하세요',
        noUpcomingAppointmentsPleaseBook: '일정 잠금을 해제하려면 약속을 예약하십시오.',
        bookAppointment: '약속 예약하기',
        bookAnotherAppointment: '약속 예약하기',
        attendedAppointments: '참여한 약속',
        aboutAppointments: {
            header: '약속 정보',
            button: '정보',
            block1: { header: '약속이란?', paragraph1: '-', paragraph2: '-' },
            block2: {
                header: '자세한 내용은 누구에게 문의하면 됩니까?',
                paragraph1: '-',
                paragraph2: '-',
            },
        },
        bookAnAppointment: '약속 예약',
        backToCalendarBtn: '일정으로 돌아가기',
        backToBookingBtn: '약속 목록으로 돌아가기',
        firstAvailable: '최초 이용 가능',
        loadingAppointment: '로드 중...',
        bookModal: {
            title: '예약 확인',
            with: '함께',
            confirm: '확인',
            continue: '계속',
            cancel: '닫기',
            first: {
                title: '이번이 당신의 첫 번째 약속입니다.',
                description:
                    '이벤트 초대를 받으려면 이 이메일 계정을 통해 개인 일정관리에 액세스할 수 있는지 확인하십시오.',
                ok: '네, 알겠습니다',
                wrongEmail: '잘못된 이메일?',
            },
            changeEmail: {
                title: '일정 이메일 선택하기',
                inputPlaceholder: '이메일 입력...',
                ok: '네 알겠습니다',
                back: '기본값 사용',
            },
            unknownErrorHeader: '예약하는 동안 오류가 발생했습니다.',
            unknownErrorBody:
                '다른 시간 예약을 시도해 보십시오. 이렇게 해도 문제가 해결되지 않으면 지원 센터에 문의하십시오.',
            confirmationHeader: '예약이 완료되었습니다!',
            bookedTheFollowing: '세부사항:',
            emailWillBeSent: '이메일이 다음 주소로 전송됨:',
            withConfirmation: '출석을 확인해 달라고 요청하고 있습니다.',
        },
        dateDetailsModal: { title: '약속 날짜' },
        completedYourProfile: '일정관리 시스템에 접근하려면 프로필을 완료해야 합니다.',
        toMyProfile: '내 프로필 편집',
    },
    chat: {
        profileSharingConfirmDialog: {
            title: '{name} 님이 당신의 프로필을 보려 합니다.',
            content: '이 사람과 프로필을 공유하시겠습니까?',
            share: '프로필 공유',
            reject: '아니요',
        },
    },
    companyDetail: {
        locations: {
            header: '위치',
            viewAll: '모두 보기',
            noLocations: '위치 없음',
            allLocations: '모든 위치',
        },
        jobModule: {
            header: '맨 위 위치',
            viewAllJobs: '{companyName}에서 올린 모든 채용 공고 보기',
            noPositions: '{companyName}(은)는 Highered에 채용 공고가 없습니다.',
            defaultLabel: '구인 중인 채용 공고',
        },
        videos: {
            header: '비디오',
            noVideos: '동영상 없음',
            noMoreVideos: '더 이상 동영상 없음',
            moreVideosFrom: '{companyName}의 추가 동영상',
        },
        articles: {
            header: '기사들',
            noArticles: '기사 없음',
            noMoreArticles: '더 이상 기사 없음',
            moreArticlesFrom: '{companyName}의 추가 기사',
        },
    },
    components: {
        builders: {
            searchable: { create: '만들기' },
            yearMonthPicker: { defaultSelect: '월 선택' },
            localeDropdown: {
                languages: { en: '영어', cn: '중국어', fr: '프랑스어' },
            },
        },
        miscellaneous: {
            verifyModule: {
                title: '학교 이메일 확인',
                description:
                    '이는 빠른 프로세스로 귀한 채용 게시물, 스킬\n 테스트 및 경력 자료와 같은\n 독점적인 기능에 대한 액세스를 줄 것입니다.',
                verificationPending: '확인 보류 중',
                weHaveSentAnEmail:
                    '\n 당신이 본인 확인을 할 수 있도록\n {strong}{studentEmail}</strong>(으)로 이메일을 보냈습니다. 많은 학교가 들어오는 이메일에\n 엄격한 편이므로 스팸 폴더를 반드시\n 확인하십시오.',
                verifyMe: '본인 확인',
                resendVerifyEmail: '확인 이메일 다시 보내기',
                cancelVerification: '확인 취소',
                emailSent: '이메일 보냄',
                emailSentMessage:
                    '이메일이 성공적으로 전송되었습니다. 받지 못할 경우 support@highered.global로 문의하시기 바랍니다.',
                resendErrorTitle: '이메일을 다시 보내는 중 오류 발생',
                resendErrorMessage:
                    '확인 이메일을 다시 보낼 수 없습니다. support@highered.global로 문의하시기 바랍니다.',
                verificationCancelledTitle: '확인 취소됨',
                verificationCancelledMessage: '확인이 성공적으로 취소되었습니다.',
                cancelErrorTitle: '취소 중 오류 발생',
                cancelErrorMessage:
                    '확인을 취소할 수 없었습니다. support@highered.global로 문의하시기 바랍니다.',
            },
            verifyModuleDialog: {
                title: '학교 이메일 확인',
                university: '학술 기관',
                studentEmail: '귀하의 교육용 이메일',
                studentEmailPlaceholder: '학술 이메일',
                message: '메시지',
                verify: '확인',
                sendRequest: '요청 보내기',
                verificationInProcess: '확인 진행 중',
                emailHasBeenSentTo:
                    '{strong}{email}</strong>(으)로 이메일이 전송되었습니다. {strong}{schoolName}</strong>에 대한 연결을 확인하려면 해당 지침을 따르십시오.',
                verificationRequestSentNonAcademic:
                    '{strong}{schoolName}</strong>의 경력 서비스에서 연결 상태를 확인해야 합니다. 그럴 경우 이메일로 알려드립니다.',
                ifNoEmailRecieved: '확인 메일을 받지 못하셨다면 저희에게 연락해주세요.',
                contactHelp: '도움이 필요하면 연락해주세요',
                doNotHaveAcademicEmail: '저는 학교 이메일 주소가 없습니다.',
                doubleCheckEmail:
                    '이 이메일 주소가 올바른지, 액세스 권한이 있는지 다시 한 번 확인하세요.',
                haveAcademicEmail: '저는 학교 이메일 주소가 있습니다.',
                noAcademicEmailInfo:
                    '교육용 이메일 주소를 사용하지 않는 경우, 귀하의 요청은 경력 서비스 부서에서 수동으로 승인해야 합니다. 따라서 신원을 식별할 수 있는 짧은 메시지를 제공해주세요.',
                alreadyVerifiedInfo: '당신은 이미 이 학교에서 인증을 받았습니다.',
            },
        },
        navigation: {
            navigation: {
                myPage: '내 페이지',
                jobs: '채용 공고',
                companies: '회사들',
                resources: '마스터 클래스',
                assessments: '평가',
                countryGuides: '국가 가이드',
                goToHaigui: '채용 공고',
                signIn: '로그인 / 회원가입',
                vfairs: '가상 이벤트',
                events: '이벤트',
                newFeature: '새로운 기능!',
            },
            profileNavigation: { signOut: '로그아웃' },
            sidebar: {
                myPage: '내 페이지',
                myProfile: '내 프로필',
                findJobs: '채용 공고 찾기',
                findCompanies: '회사 찾기',
                resources: '마스터 클래스',
                assessments: '평가',
                countryGuides: '국가 가이드',
                goToHaigui: '중국의 채용 공고',
                virtualFairs: '가상 이벤트',
                logOut: '로그아웃',
            },
            backToCalendar: '일정으로 돌아가기',
            allBooths: '모든 부스',
            home: '홈',
        },
        smart: {
            companyModule: {
                followJob: '즐겨찾기에 추가',
                followCompany: '회사 팔로잉하기',
                unFollowJob: '즐겨찾기에서 제거',
                unFollowCompany: '회사 팔로잉 취소',
                favoritedTitle: '즐겨찾기에 저장',
                favoritedMessage:
                    '이 위치가 즐겨찾기에 저장되었습니다. 내 페이지에서 좋아하는 포지션을 찾으세요.',
                unfavoritedTitle: '즐겨찾기에서 제거됨',
                unfavoritedMessage: '이 위치가 즐겨찾기에서 제거되었습니다.',
                favoriteErrorTitle: '뭔가 잘못되었습니다',
                favoriteErrorMessage: '이 포지션을 즐겨찾기에 추가할 수 없었습니다',
                showAllCompanies: '모든 회사 표시',
                showOnlyCompaniesLiveOnChat: '채팅에서 회사만 실시간으로 표시',
            },
            profileModule: {
                profileCompletion: '프로필 완료',
                profileCompletionEncouragement:
                    '당신의 프로필의 마지막 {percentageLeft}을(를) 완료하여 고용주에게 자신을 보여 줍니다.',
                gotoProfilePage: '프로필 업데이트',
                profileCompleted: '프로필 완료',
                profileCompletedWhatsNext:
                    '대부분의 고용주가 채용 과정에서 온라인 평가를 사용한다는 사실을 알고 계셨습니까? 지금 연습해서 당신의 강점과 약점에 대한 통찰력을 얻어보세요.',
                gotoTestsPage: '평가 센터로 이동',
                authIndication: {
                    title: '당신의 꿈의 직업을 찾아보세요.',
                    description:
                        '귀하의 학교에 잘 올라오지 않는 직무와 구직 활동량을 늘려줄 테스트에 액세스 하길 원하시나요? Google, LinkedIn 또는 Facebook으로 계정을 쉽게 만들 수 있습니다.',
                    action: '출발!',
                },
                toProfileHint: '내 프로필에',
                toProfileUncompletedHint:
                    '프로필이 100% 완벽하지 않습니다. 채용 가능성을 극대화하기 위해 완료해주세요.',
                profileActions: {
                    addFirstName: '이름 추가',
                    addLastName: '성 추가',
                    addNationality: '국적 추가',
                    addPhoneNumber: '전화 번호 추가',
                    addLanguage: '언어 추가',
                    addEducation: '교육 추가',
                    addEmail: '이메일 추가',
                    addGender: '성별 추가',
                },
            },
            featuredCompanies: { label: '주요 기업' },
            featuredPositions: { label: '주요 직무' },
            featuredResource: {
                header: '가상 컨퍼런스 참여',
                cta: '지금 시청하세요!',
                wechatSignupHeader: 'Highered의 WeChat 계정에 따라 업데이트를 받아보세요.',
            },
        },
    },
    '"': '今すぐコードをスキャンする！',
    cts: {
        filterNames: {
            employment_types: '고용형태',
            education_level: '학위',
            job_category: '필드',
            address: '위치',
            sector: '섹터',
            exclude_school_id: '제외',
            languages: '언어들',
        },
        excludeSchoolIds: {
            '-1': '공유 게시물',
            unknownSchoolId: 'EFMD 학교 파트너',
        },
        educationLevels: {
            BACHELORS_OR_EQUIVALENT: '학사',
            MASTERS_OR_EQUIVALENT: '석사',
            DOCTORAL_OR_EQUIVALENT: '박사',
            MBA_OR_EQUIVALENT: 'MBA',
            DBA_OR_EQUIVALENT: 'DBA',
        },
        employmentTypes: {
            FULL_TIME: '풀타임',
            INTERN: '인턴쉽',
            TEMPORARY: '아르바이트',
            PART_TIME: '아르바이트',
        },
        startDate: '시작',
        educationFields: {
            ACCOUNTING_AND_FINANCE: '회계 및 재무',
            ADMINISTRATIVE_AND_OFFICE: '행정 및 사무',
            ADVERTISING_AND_MARKETING: '광고 및 마케팅',
            ART_FASHION_AND_DESIGN: '예술 패션 및 디자인',
            BUSINESS_OPERATIONS: '비즈니스 운영',
            COMPUTER_AND_IT: '컴퓨터 및 IT',
            CUSTOMER_SERVICE: '고객 서비스',
            EDUCATION: '교육',
            HEALTHCARE: '헬스케어',
            HUMAN_RESOURCES: '인적 자원',
            INSTALLATION_MAINTENANCE_AND_REPAIR: '설치 유지보수 및 수리',
            LEGAL: '법적',
            MANAGEMENT: '관리',
            MANUFACTURING_AND_WAREHOUSE: '제조 및 창고',
            MEDIA_COMMUNICATIONS_AND_WRITING: '미디어 커뮤니케이션즈 및 글쓰기',
            OIL_GAS_AND_MINING: '에너지',
            PROTECTIVE_SERVICES: '보호 서비스',
            REAL_ESTATE: '부동산',
            SALES_AND_RETAIL: '세일즈 및 리테일',
            SCIENCE_AND_ENGINEERING: '이공계',
            SOCIAL_SERVICES_AND_NON_PROFIT: '사회 서비스 및 비영리',
            TRANSPORTATION_AND_LOGISTICS: '운송 및 물류',
        },
        sectors: {
            Consulting: '자문',
            'Consumer Goods': '소비재',
            'Financial Services / Banking': '금융 서비스/은행',
            'Goverment / Public Administration / Non Profit': '정부 / 공공행정 / 비영리',
            'International Trade & Development': '국제 무역 & 개발',
            Manufacturing: '제조업',
            'Media / Entertainment': '미디어/엔터테인먼트',
            'Petroleum / Energy': '석유 / 에너지',
            'Pharma / Healthcare / Biotech': '약국 / 의료 / 생명공학',
            'Real Estate / Construction / Infrastructure': '부동산/건설/인프라',
            'Technology (IT) / Telecom': '기술 (IT)/통신',
            'Transportations & Logistics': '운송 & 물류',
            Other: '기타',
        },
        countries: {
            'China (Hong Kong SAR)': '홍콩',
            'Costa Rica': '코스타리카',
            'Europe & Sub-Saharan Africa': '유럽 & 사하라 이남 아프리카',
            'Hong Kong': '홍콩',
            'Korea, South': '대한민국',
            'New Zealand': '뉴질랜드',
            'Papua-Ny Guinea': '파푸아뉴기니',
            'Puerto Rico': '푸에르토리코',
            'Saudi Arabia': '사우디아라비아',
            'South Africa': '남아프리카 공화국',
            'South Korea': '대한민국',
            'Sri Lanka': '스리랑카',
            'Taiwan (Province of China)': '타이완',
            'The Seychell Islands': '세이셸',
            'United Arab Emirates': '아랍에미리트',
            'United Kingdom': '영국',
            'Ivory Coast': '코트디부아르',
            Afghanistan: '아프가니스탄',
            Algeria: '알제리',
            Angola: '앙골라',
            Argentina: '아르헨티나',
            Armenia: '아르메니아',
            Australia: '호주',
            Austria: '오스트리아',
            Azerbaijan: '아제르바이잔',
            Bahamas: '바하마',
            Bahrain: '바레인',
            Bangladesh: '방글라데시',
            Belarus: '벨라루스',
            Belgium: '벨기에',
            Botswana: '보츠와나',
            Brazil: '브라질',
            Bulgaria: '불가리아',
            Cambodia: '캄보디아',
            Canada: '캐나다',
            Chile: '칠레',
            China: '중국',
            Colombia: '콜롬비아',
            Congo: '콩고',
            Croatia: '크로아티아',
            Cyprus: '키프로스',
            Czechia: '체코',
            Denmark: '덴마크',
            Ecuador: '에콰도르',
            Egypt: '이집트',
            Estonia: '에스토니아',
            Ethiopia: '에티오피아',
            Fiji: '피지',
            Finland: '핀란드',
            France: '프랑스',
            Germany: '독일',
            Ghana: '가나',
            Greece: '그리스',
            Guernsey: '건지',
            Hungary: '헝가리',
            Iceland: '아이슬란드',
            India: '인도',
            Indonesia: '인도네시아',
            Iraq: '이라크',
            Ireland: '아일랜드',
            Israel: '이스라엘',
            Italy: '이탈리아',
            Japan: '일본',
            Jersey: '저지',
            Jordan: '조던',
            Kazakhstan: '카자흐스탄',
            Kenya: '케냐',
            Kuwait: '쿠웨이트',
            Laos: '라오스',
            Latvia: '라트비아',
            Lebanon: '레바논',
            Lithuania: '리투아니아',
            Luxembourg: '룩셈부르크',
            Malaysia: '말레이시아',
            Malta: '몰타',
            Mauritania: '모리타니',
            Mauritius: '모리셔스',
            Mexico: '멕시코',
            Mongolia: '몽골',
            Morocco: '모로코',
            Myanmar: '미얀마',
            Namibia: '나미비아',
            Netherlands: '네덜란드',
            Nigeria: '나이지리아',
            Norway: '노르웨이',
            Oman: '오만',
            Pakistan: '파키스탄',
            Panama: '파나마',
            Paraguay: '파라과이',
            Peru: '페루',
            Philippines: '필리핀',
            Poland: '폴란드',
            Portugal: '포르투갈',
            Qatar: '카타르',
            Romania: '루마니아',
            Russia: '러시아',
            Senegal: '세네갈',
            Serbia: '세르비아',
            Singapore: '싱가포르',
            Slovakia: '슬로바키아',
            Slovenia: '슬로베니아',
            Spain: '스페인',
            Sudan: '수단',
            Swaziland: '스와질랜드',
            Sweden: '스웨덴',
            Switzerland: '스위스',
            Syria: '시리아',
            Taiwan: '타이완',
            Tanzania: '탄자니아',
            Thailand: '태국',
            Tonga: '통가',
            Turkey: '터키',
            Ukraina: '우크라이나',
            Ukraine: '우크라이나',
            USA: '미국',
            Uzbekistan: '우즈베키스탄',
            Vanuatu: '바누아투',
            Vietnam: '베트남',
            Zambia: '잠비아',
        },
        languages: {
            Aceh: '아체',
            Afrikaans: '아프리칸스어',
            Albanian: '알바니아어',
            Amharic: '암하라어',
            Arabic: '아랍어',
            Arakanese: '아라칸어',
            Armenian: '아르메니아어',
            Azeri: '아제리어',
            Badini: '바디니어',
            Basque: '바스크어',
            Belarusian: '벨라루스어',
            Bengali: '벵골어',
            Berber: '베르베르어',
            Bosnian: '보스니아어',
            Bulgarian: '불가리아어',
            Burmese: '버마어',
            Cantonese: '광둥어',
            Catalan: '카탈루냐어',
            Cebuano: '세부아노',
            Chechen: '체첸',
            Chin: '중국어 (Chin)',
            Chinese: '중국어',
            Croatian: '크로아티아어',
            Czech: '체코어',
            Danish: '덴마크어',
            Dari: '다리어',
            Dutch: '네덜란드어',
            English: '영어',
            Estonian: '에스토니아어',
            Faroese: '페로어',
            Filipino: '필리핀어',
            Finnish: '핀란드어',
            French: '프랑스어',
            German: '독일어',
            Greek: '그리스어',
            Greenlandic: '그린란드어',
            Hausa: '하우사어',
            Hebrew: '히브리어',
            Hindi: '힌두어',
            Hungarian: '헝가리어',
            Icelandic: '아이슬란드어',
            Indonesian: '인도네시아어',
            Italian: '이탈리아어',
            Japanese: '일본어',
            Kazakh: '카자흐어',
            Kinyarwanda: '키냐르완다어',
            Kirundi: '키룬디어',
            Korean: '한국어',
            Kurdish: '쿠르드어',
            Kurmanji: '쿠르만지어',
            Kven: '크벤어',
            Latin: '라틴어',
            Latvian: '라트비아어',
            Lingala: '링갈라어',
            Lithuanian: '리투아니아어',
            Macedonian: '마케도니아어',
            Malagasy: '마다가스카르어',
            Malaysian: '말레이시아어',
            Mandarin: '표준 중국어',
            Mongolian: '몽골어',
            Nepali: '네팔어',
            Norwegian: '노르웨이어',
            Oromo: '오로모어',
            Other: '기타',
            Panjabi: '펀자브어',
            Pashto: '파슈토어',
            Persian: '페르시아어',
            Polish: '폴란드어',
            Portuguese: '포르투갈어',
            Punjabi: '펀자브어',
            Romanes: '로마어',
            Romani: '로마니어',
            Romanian: '루마니아어',
            Russian: '러시아어',
            Sami: '사미어',
            Serbian: '세르비아어',
            Sign_language: '수화',
            Slovak: '슬로바키아어',
            Slovene: '슬로베니아어',
            Somali: '소말리아어',
            Sorani: '소라니어',
            Spanish: '스페인어',
            Swahili: '스와힐리어',
            Swedish: '스웨덴어',
            Tagalog: '타갈로그어',
            Tamil: '타밀어',
            Thai: '태국어',
            Tigrinya: '티그리냐어',
            Turkish: '터키어',
            Ukrainian: '우크라이나어',
            Urdu: '우르두어',
            Uyghur: '위구르어',
            Vietnamese: '베트남어',
            Wolof: '월로프어',
        },
    },
    emailverification: {
        headerLabel: '이메일 확인',
        verifyingEmail: '이메일 확인중',
        emailVerifySuccess: '이메일이 확인되었습니다!',
        emailVerifyFailure: '뭔가 잘못됐어요... 나중에 다시 시도하거나 고객 지원팀에 문의하십시오.',
        gotoMyPage: '내 페이지로 돌아가기',
    },
    errors: {
        defaultErrorMessage: '오류가 발생했습니다!',
        logInErrorText: {
            invalidCredentials: '잘못된 사용자 이름 또는 비밀번호',
            inactiveUser:
                '제공된 이메일이 있는 사용자가 비활성화되어 있습니다. 이메일에서 계정 활성화 작업을 확인하거나 비밀번호를 재설정해 보십시오.',
            default: '인증할 수 없었습니다.',
        },
        registerErrorText: {
            passwordTooShort: '비밀번호는 8자리 이상이어야 합니다.',
            emailAlreadyInUse: '제공된 이메일이 이미 사용 중입니다.',
            emailTaken:
                '이메일이 이미 사용 중입니다. 학교 이메일을 사용한 경우 플랫폼이 업그레이드되기 전에 사용자가 있었기 때문에 이러한 문제가 발생할 수 있습니다(higheredtalent.org에서).',
            default: '사용자를 생성할 수 없었습니다.',
        },
        invalidTokenText: { default: '토큰이 잘못되었거나 만료되었습니다.' },
        passwordErrorText: {
            passwordTooShort: '비밀번호는 8자리 이상이어야 합니다.',
            requireNonAlphanumeric: '비밀번호에는 특수 문자가 하나 이상 포함되어야 합니다.',
            requireLowerCase: '비밀번호에는 하나 이상의 소문자가 포함되어야 합니다.',
            requireUpperCase: '비밀번호에는 하나 이상의 대문자가 포함되어야 합니다.',
            requireUniqueChars: '비밀번호는 6자 이상이어야 합니다.',
            default: '비밀번호를 변경할 수 없었습니다.',
        },
        recoverErrorText: {
            userNotFound: '사용자가 존재하지 않습니다! 지원팀에 문의하십시오.',
            userAlreadyActive: '사용자가 이미 활성화되었습니다!\n로그인을 시도하십시오.',
            emailAlreadyInUse:
                '제공된 이메일이 이미 사용 중입니다.\n 계정 활성화를 계속하려면 다른 이메일이나 다른 소셜 로그인을 시도해 보십시오. 그렇지 않으면 홈페이지로 이동하여 계정에 로그인해주세요.',
            default: '계정을 활성화할 수 없습니다.\n나중에 다시 시도하십시오.',
        },
        socialAuthErrorText: {
            errorTitle: '{provider}(으)로 로그인할 수 없음',
            invalidProviderGoogle:
                '제공된 이메일이 있는 사용자가 Google에 연결되어 있지 않습니다. LinkedIn, Facebook 또는 이메일로 로그인해 보십시오.',
            invalidProviderFacebook:
                '제공된 이메일이 있는 사용자가 Facebook에 연결되어 있지 않습니다. Google, LinkedIn 또는 이메일로 로그인해 보십시오.',
            invalidProviderLinkedIn:
                '제공된 이메일이 있는 사용자가 LinkedIn에 연결되어 있지 않습니다. Google, Facebook 또는 이메일로 로그인해 보십시오.',
            invalidProviderWeChat:
                '제공된 이메일이 있는 사용자가 WeChat에 연결되어 있지 않습니다. Google, Facebook 또는 이메일로 로그인해 보십시오.',
        },
        uniConnErrorText: {
            emailNotAvailable:
                '제공한 이메일이 이미 사용 중입니다. 이는 플랫폼이 업그레이드되기 전에 사용자가 있었기 때문일 수 있습니다(higheredtalent.org 참조). 지원팀에 문의하십시오.',
            invalidEmailDomain:
                '제공된 이메일 도메인이 제공된 대학과 일치하지 않습니다. 올바른 대학을 선택하세요.',
            existingConnection: '사용자가 제공된 대학에 이미 연결되어 있습니다.',
            default: '검증을 시작할 수 없습니다.',
        },
        spotlightErrors: {
            userUpdate: {
                emailAlreadyInUse: '이메일이 이미 사용 중입니다.',
                default: '업데이트할 수 없음',
            },
        },
    },
    favorites: {
        header: '내 즐겨찾기',
        active: '활성',
        expired: '만료됨',
        expiresThisMonth: '이번 달 지원 마감일',
        expiresThisWeek: '이번 주 지원 마감일',
        expiresLater: '추후 신청 마감일',
        noActiveFavorites: '현재 선호하는 직무가 없습니다',
        noExpired: '만료된 즐겨찾기 직무가 없습니다',
    },
    findcompanies: { headerLabel: '회사 찾기', companyListLabel: '회사들' },
    findjobs: {
        header: '채용 공고 찾기',
        changeFilters: '필터 변경',
        recruitmentModule: {
            body: '채용 담당자, 직업 전문가 또는 학생 인재 채용에 관심이 있으십니까?',
            createJob: '작업 게시물을 만들려면 여기를 클릭하십시오.',
        },
    },
    general: {
        documentTitle: '글로벌 기회 플랫폼',
        email: '이메일',
        password: '비밀번호',
        confirmPassword: '비밀번호 확인',
        loading: '로딩중',
        ok: '네, 알겠습니다',
        save: '저장하기',
        add: '추가하기',
        close: '닫기',
        delete: '삭제',
        cancel: '취소',
        done: '완료됨',
        continue: '계속',
        back: '뒤',
        next: '다음.',
        finish: '끝내기',
        success: '성공',
        error: '오류',
        description: '설명',
        months: {
            '0': '1월',
            '1': '2월',
            '2': '3월',
            '3': '4월',
            '4': '5월',
            '5': '6월',
            '6': '7월',
            '7': '8월',
            '8': '9월',
            '9': '10월',
            '10': '11월',
            '11': '12월',
        },
        days: {
            '0': '일',
            '1': '월',
            '2': '화',
            '3': '수',
            '4': '목',
            '5': '금',
            '6': '토',
        },
        dialogs: {
            helperTexts: {
                checkHasPendingAction: '보류 중인 검증 확인중',
                verifySchoolConnection: '이러한 리소스에 액세스하려면 학교 연결을 확인하십시오.',
                logInToAccessMoreFeatures: '수천 건의 국제 경력 기회',
            },
        },
        minutesShort: '분',
        poweredBy: '다음에 의한 지원:',
    },
    gptw: {
        company: {
            alt: 'GPTW',
            tooltip: "이 회사는 'Great Place To Work' 인증 회사입니다.",
        },
        posting: {
            label: {
                alt: 'GPTW',
                tooltip:
                    "이 게시글은 '일하기 좋은 곳 (Great Place To Work)' 회사에서 올라온 글입니다.",
            },
            detail: {
                alt: 'GPTW',
                tooltip: {
                    isCertified: '{companyName}은(는) 가장 일하기 좋은 기업입니다.',
                    description: '-',
                    readMore: '자세히 읽으려면 클릭하십시오.',
                },
            },
        },
    },
    jobdetail: {
        detailModule: {
            deadline: '신청기한',
            location: '위치',
            employmentType: '고용형태',
            languageRequirements: '언어 요구 사항',
            workPermitRequirements: '작업 허가 요건',
            preferredEducationField: '선호 교육 분야',
            preferredEducationLevel: '선호 교육 수준',
            jobTags: '태그',
            apply: '지금 적용',
            verificationRequired: '신청하려면 학교 이메일을 확인해야 합니다.',
            verificationRequiredHint: '신청하려면 학교 이메일을 확인해야 합니다.',
            verificationPending: '이 학교에서 보류 중인 검증이 있습니다.',
            verificationPendingHint: '이 학교에서 보류 중인 검증이 있습니다.',
        },
        invalidJobAd: {
            caption:
                '죄송하지만 해당 직무를 찾을 수 없습니다. 오류가 발생한 것으로 판단되면 아래 대화 상자를 사용하여 지원팀에 문의하십시오.',
            btn: '다른 작업 찾기',
        },
    },
    mypage: {
        header: '내 페이지',
        suggestedPositions: '제안된 위치',
        favoriteModule: {
            header: '내 즐겨찾기 직무',
            seeAll: '모두 보기',
            noFavorites: '현재 선호하는 직무가 없습니다.',
        },
    },
    recoverpassword: {
        createPassword: '새 비밀번호 만들기',
        newPasswordLabel: '새 비밀번호',
        newPasswordPlaceholder: '비밀번호',
        confirmPasswordLabel: '비밀번호 확인',
        confirmPasswordPlaceholder: '비밀번호 확인',
        resetPasswordButton: '비밀번호 재설정',
        resettingPassword: '비밀번호 재설정 중',
        passwordsNotMatching: '비밀번호가 일치하지 않습니다.',
    },
    recoveruser: {
        headerLabel: 'Highered 사용자 복구',
        accountActivation: '계정 활성화',
        step1: {
            header: '새로운 플랫폼에 오신 것을 환영합니다!',
            subHeader: '계정에 연결할 방법을 선택하십시오.',
            description:
                '더 간단한 로그인 프로세스를 위해 계정을 다음 서비스 중 하나 이상에 연결하는 것이 좋습니다.',
            OR: '아니면',
            emailAndPassword: '사용자 자신의 이메일 사용',
        },
        step2: {
            header: '이메일 및 비밀번호 사용',
            description:
                '이것은 당신의 계정에 연결될 주 이메일입니다. 졸업 후에도 데이터에 계속 액세스하려면 대학 주소와 다른 이메일을 사용하는 것이 좋습니다. 계정 설정에서 당사에서 어떤 이메일을 받는지 쉽게 제어할 수 있습니다.',
            invalidEmail: '제공된 이메일이 올바른 이메일이 아닙니다.',
            passwordsNotMatch: '비밀번호는 일치해야 합니다.',
            passwordDescription01:
                '계정 보안을 유지하려면 새 비밀번호를 설정해야 합니다. 다음을 사용하여 비밀번호를 생성하십시오.',
            passwordDescription02: '최소 8자',
            passwordDescription03: '하나 이상의 소문자(a-z)',
            passwordDescription04: '하나 이상의 대문자(A-Z)',
            passwordDescription05: '하나 이상의 숫자 또는 특수 기호(0-9, !#$ 등)',
            passwordDescription06: '고유 문자 6자 이상',
            repeatPassword: '반복 비밀번호',
        },
        step3: {
            header: '사용자 활성화 중',
            loadingHints: {
                '0': '사용자 데이터 로드 중',
                '1': '모두 준비 시키기',
                '2': '코앞에 닥친 새로운 가능성',
                '3': '거의 다 했어요!',
            },
            successHeader: '이제 계정을 사용할 수 있습니다!',
            successSubheader: '이제 새로운 독점 기능에 액세스할 수 있습니다!',
            errorHeader: '계정을 활성화할 수 없습니다.',
            ifWrongContact: '이 문제가 잘못되었다고 생각되면 지원팀에 문의하십시오.',
            contactForHelp: '도움이 필요한 연락처',
            goBack: '돌아가다',
        },
    },
    resourcesInternal: {
        header: '자원',
        resourceTypeHeader: '유형',
        resourceNoContent: '학교에서 아직 리소스 기능을 활성화하지 않았습니다.',
        resourceFolderNoContent: '이 폴더에 사용 가능한 리소스가 없습니다.',
        resourceTitleHeader: '제목',
        resourcePublishDateHeader: '발표됨',
        searchPlaceholder: '이름 또는 키워드 검색...',
        cvTemplateHeader: '높은 CV 템플릿(ATS 친화적)',
        cvTemplateSubtitle: '다운로드하세요!',
    },
    shared: {
        userNavSection: {
            myPage: '내 페이지',
            myProfile: '내 프로필',
            myTests: '평가',
            myApplications: '신청서',
            myFavorites: '즐겨찾기',
            internalResources: '자원',
            calendar: '달력',
            documents: 'CV 업로드',
        },
        searchModule: {
            searchBar: { label: '제목 또는 키워드로 검색하기' },
            filters: { clearFilters: '필터 지우기' },
            filterLimit: {
                title: '필터 제한에 도달했습니다.',
                message: '이 유형의 필터를 더 이상 선택할 수 없습니다.',
            },
        },
        postingModule: {
            postingModule: {
                positions: '위치',
                estimatedCount: '{totalCount}의 ca {count}개',
                knownCount: '{totalCount}의 {count}개',
                noMatchFound: '기준에 맞는 항목을 찾을 수 없습니다.',
            },
            postItem: { applyBefore: '신청기한' },
            postCard: { deadline: '마감일' },
        },
        loginModule: {
            emailVerificationTip: '받은 편지함에 도착하는 데 몇 분 정도 걸릴 수 있습니다.',
            noEmail: '이메일 없습니까? 스팸 필터를 확인하거나 다음을 수행하십시오.',
            logIn: '로그인',
            socialAuthBtns: {
                continueWithFacebook: 'Facebook으로 계속하기',
                continueWithGoogle: 'Google로 계속하기',
                continueWithLinkedIn: 'LinkedIn으로 계속하기',
                continueWithWeChat: 'WeChat 계속하기',
            },
            verifyEmail: {
                verifyYourEmail: '이메일을 확인하십시오.',
                weSentAnEmailTo: '다음으로 확인 이메일을 보냈습니다:',
                continueToSignIn: '로그인 계속하기',
                resendEmail: '확인 링크 다시 보내기',
                newEmailSent: '새 이메일 전송',
            },
            registerForm: {
                recommendation:
                    '\n 졸업 후 데이터에 액세스할 수 있도록 하려면\n학교 이메일이 아닌 개인용 이메일을 사용하는 것이 좋습니다.',
                register: '등록하기',
                passwordsNotMatch: '비밀번호가 일치하지 않습니다.',
            },
            logInPaper: {
                useEmail: '또는 이메일을 사용합니다.',
                noAccount: '계정이 없다고요?',
                signUp: '회원가입',
                logInToAccess: '이 기능에 액세스하려면 로그인',
                showAllOptions: '모든 로그인 옵션 표시',
                hideAllOptions: '줄이기',
            },
            logInForm: {
                logIn: '로그인',
                forgotPassword: '비밀번호를 잊으셨습니까?',
            },
            forgotPassword: {
                title: '비밀번호 재설정 요청',
                description:
                    '걱정 마세요. 누구나 이따금씩 비밀번호를 잊어버립니다.\n 비밀번호를 재설정하려면 아래 이메일을 입력하십시오.',
                resetPassword: '비밀번호 재설정',
                emailSentTitle: '도움의 손길이 당신을 향하고 있습니다!',
                emailHasBeenSent:
                    '비밀번호를 재설정하는 방법에 대한\n <br>\n지침이 포함된 이메일이 \n <br>\n <strong>{email}</strong>(으)로 전송되었습니다. 받은 편지함을 확인하십시오.',
                noEmail: '이메일이 없습니까?',
                sendEmailOneMoreTime: '이메일 한 번 더 보내기',
                resendErrorTitle: '비밀번호 복구 중 오류 발생',
                resendErrorMessage:
                    '복구 비밀번호 이메일을 보낼 수 없었습니다. 이메일이 잘못된 건 아닐까요?',
            },
        },
        universityBadges: {
            addAnotherUniversity: '다른 대학교 추가',
            verificationDialog: {
                verifiedStudent: '{schoolAbbr}명의 학생 확인',
                verificationDescription:
                    '당신은 {email}의 이메일을 사용하는 검증된 {schoolAbbr}의 학생입니다',
                verificationDescriptionNoEmail: '당신은 검증된 {schoolAbbr}의 학생입니다',
                checkYourEmail: '당신의 {schoolAbbr} 이메일을 확인하십시오.',
                sentEmailDescription:
                    '{schoolAbbr}에 대한 확인 관련 이메일을 {email}에 보냈습니다. 이메일을 확인해 주세요.',
                resendEmail: '이메일 다시 보내기',
                cancelVerification: '취소 확인',
                notYetVerified: '대학 소속이 아직 검증되지 않았습니다.',
                verifyYourAffiliation:
                    '전용 작업 게시물 및 리소스와 같은 {schoolAbbr}의 특정 기능에 액세스하려면 가입 여부를 확인하십시오.',
                verify: '확인',
                goToPlatform: '플랫폼으로 이동',
                verificationPending: '확인 보류 중',
                verificationPendingDescription:
                    '{schoolAbbr}의 경력 서비스에서 귀하의 요청을 확인하고 있습니다. 확인이 완료되면 이메일로 연락을 드릴 것입니다.',
            },
        },
        universityAvatar: {
            dialogs: {
                verificationDialog: {
                    verifiedStudent: '확인된 {uniSubDomain} 학생',
                    verifiedStudentWithEmail:
                        '당신은 {email}의 이메일을 사용하는 검증된 {uniSubDomain} 학생입니다.',
                    checkEmail: '당신의 {uniSubDomain} 이메일을 확인하십시오.',
                    sentEmailInfo:
                        '{uniSubDomain}에 대한 확인 관련 이메일을 {email}의 주소로 보냈습니다. 이메일을 확인해 주세요.',
                    resendEmail: '이메일 다시 보내기',
                    cancelVerification: '확인 취소',
                    notYetVerified: '대학 소속이 아직 검증되지 않았습니다.',
                    resourceAccessInfo:
                        '전용 작업 게시물 및 리소스와 같은 {uniSubDomain} 특정 기능에 액세스하려면 가입 여부를 확인하십시오.',
                    verificationCancelled: '확인 취소됨',
                    emailSent: '보낸 이메일',
                },
            },
        },
        termsAndConds: {
            termsAndConditions: '이용약관',
            privacyPolicy: '개인 정보 보호 정책',
            talentPanel: '학교/고용주?',
        },
        favoriteModule: {
            favoriteCard: {
                deleted: '삭제됨',
                deletedTitle: '이 직무는 더 이상 이용 불가합니다',
            },
        },
        pageNotFound: {
            header: '404',
            description: '찾던 페이지가 더 이상 없는 것 같네요.',
            goToHome: '홈 페이지로 이동',
            contactus: '문의',
        },
        chat: {
            liveNow: '지금 라이브 채팅 진행 중!',
            seeAll: '모두',
            schoolSpecificChats: '빠른 액세스',
            help: '도와드릴까요?',
            chatExistsLabel: '채팅이 존재합니다',
        },
        countdown: {
            day: '일',
            days: '일',
            hour: '시',
            hours: '시간',
            minute: '분',
            minutes: '분',
            second: '초',
            seconds: '초',
        },
    },
    spotlight: {
        header: '내 프로필',
        saveChangesToSubmit: '변경 내용을 적용하려면 프로필을 저장하십시오.',
        saveChanges: '변경 사항 저장',
        saveSuccessful: '변경 내용이 저장되었습니다.',
        personalDetails: {
            header: '개인내역',
            firstName: '이름',
            lastName: '성',
            nationality: '국적',
            gender: '성별',
            uploadProfileImage: '사진 업로드',
            genderOptions: {
                male: '남자',
                female: '여자',
                other: '기타',
                none: '대답하고 싶지 않습니다',
                unknown: '알 수 없음',
            },
            wrongFileTypeErrorHeader: '잘못된 파일 형식',
            wrongFileTypeErrorDescription: '이미지만 업로드할 수 있습니다.',
        },
        summary: { header: '총괄요약' },
        contactDetails: {
            header: '연락처 세부 정보',
            contactEmail: '연락처 이메일',
            phoneNumberHeader: '휴대폰 번호',
            countryCode: '국가코드',
            phoneNumber: '전화번호',
            invalidEmail: '입력한 이메일은 올바른 이메일이 아닙니다.',
            permanentEmail:
                '참고: 이 변경 사항은 영구적입니다. 이메일은 한 번만 설정할 수 있습니다.',
        },
        languages: {
            header: '언어',
            languageLabel: '언어',
            levelLabel: '레벨',
            addLanguage: '새 언어 추가',
            proficiencies: {
                '22f882cc-3cb0-4cfd-a590-ef010f4d798b': '초등 숙련도',
                '82edcac6-693b-42ea-bf24-0a52774f395c': '제한된 작업 숙련도',
                'a97f6798-7280-4ce7-8896-6d4a8fb58c63': '전문 업무 숙련도',
                '93b37709-3f2d-4853-ac77-b8c0dd07243e': '완전한 전문적 숙련도',
                '250d296e-d6db-46fb-8c44-07950db80ec4': '원어민 또는 이중언어 구사 능력',
            },
        },
        education: {
            header: '교육',
            addEducation: '교육 추가',
            notGraduated: '졸업 예정',
            graduatedIn: '{date}에 졸업 예정',
            dialog: {
                addNewEducation: '새 교육 추가',
                degreeTitle: '프로그램',
                institution: '기관',
                degreeType: '학위',
                fieldOfStudy: '연구 분야',
                cannotFindField: '내 필드를 찾을 수 없습니다.',
                studyStart: '시작월',
                studyEnd: '졸업월',
                invalidDegreeTitle: '프로그램 제목을 입력해야 합니다.',
                invalidSchool: '학교를 선택해야 합니다.',
                invalidStartDate: '시작 날짜를 선택하십시오.',
                invalidEndDate: '졸업일을 선택하세요.',
                invalidStudyPeriod: '시작일 전에는 졸업할 수 없습니다.',
                invalidDegreeField: '올바른 학문 영역을 입력하십시오.',
                invalidDegreeLevel: '올바른 학위 수준을 선택하십시오.',
                selectStartDate: '시작일',
                selectEndDate: '졸업일',
                degrees: {
                    '5b468395-7bf7-4f14-88d9-32096884d4ef': '학사',
                    '09f419fa-1517-41ce-970c-df0d073fc440': '석사',
                    '2c917ed6-5bb7-4e23-95ab-60c55d8df135': 'MBA',
                    '1fff1451-f07c-415c-954a-63b1e5f44fc8': 'DBA',
                    '2fbd6155-d939-40cc-970d-283be0aef433': '박사',
                },
                diciplins: {
                    '383c2086-24da-4fe2-977b-7e3d4da85f8e': '농림어업',
                    'c8fb1348-bdac-4ed3-af7a-a831376d04b7': '응용 과학 & 직업',
                    '5c665d94-5124-4226-a4f6-da8cca47e3f6': '예술, 디자인 & 건축',
                    '06b028e2-d7ed-4281-8668-1009d6da1c35': '비즈니스 & 관리',
                    '747624bb-0174-4961-a3c0-dbe4f1cb750d': '컴퓨터 과학 & IT',
                    'ede2bbdb-7a1d-466c-99e5-bcab52e07d69': '경제학',
                    '5c0432d4-9297-429a-85c4-3305d207764e': '교육 & 훈련',
                    '8198b6ea-5b28-4be2-afbc-45df759c65cb': '엔지니어링 & 기술',
                    '7e5c0527-d1ec-4125-945e-138ec473e8dd': '환경학 & 지구과학',
                    '3babe28b-6285-4a03-b0b8-43f55be393cd': '호텔, 레저 & 스포츠',
                    '9eebcc51-385e-4122-88a1-6dd3efbaf896': '인문학',
                    '390cf111-b55a-4bb7-a6b6-1cc2b21a248f': '저널리즘 & 미디어',
                    'a2744908-9521-4330-a07d-3680b058d0a6': '법',
                    '947993e1-b723-4d85-8cd9-a4ae46cd623e': '마케팅',
                    'c98802c8-74a5-4a98-99ba-84eb76fd1a60': '혁신과 비즈니스 분야의 과학 석사',
                    'bca263cc-3d17-4ad8-b70e-e2bfe04421fa': '개발 관리 석사',
                    'a37667e2-5713-4157-82e9-78c10760d2de': '데이터 과학 석사',
                    '72277bb7-9d5e-422a-a2b4-8a8fb8be7143': '의학 & 건강',
                    'bd84a8cd-ce66-4c61-86a8-7fcb6644cc5d': '재무학 석사',
                    '9e665ac9-9611-4508-af4b-22e91f167ea4': '국제 비즈니스 연구학 석사',
                    'baf5bb0a-d0ab-4c13-aacc-c6a8a90e2fcf': '비즈니스 분석학 석사',
                    '7d832109-642a-4730-aada-26927eb683ee': '경영학 석사',
                    'baf05a5a-faba-4f30-9254-9cd73bb63bbf': '자연과학 & 수학',
                    '828cc4ac-1f2b-4133-8e29-ba1347585ae6': '사회과학',
                    '44c1f8cf-8696-4638-bc03-9763c2de32af': '기타',
                },
            },
        },
        workAuthorization: {
            header: '작업 권한 부여',
            addWorkAuthorization: '작업 권한 추가',
            implicitValue: '국적 기준',
            dialog: {
                selectCountry: '국가선택',
                addEuWorkAuthorization: 'EU 작업 권한 추가',
            },
        },
        communication: {
            header: '커뮤니케이션',
            sendMeUpdatesDescription: '경력 소식, 직위, 회사 소식 메일로 보내주세요.',
        },
        errors: {
            imageUpload: {
                title: '이미지를 업로드할 수 없습니다.',
                message: '이미지가 너무 큽니다!',
            },
        },
        exitDialog: {
            title: '저장되지 않은 변경 내용이 손실됩니다.',
            message:
                '변경 내용을 저장하지 않고 페이지를 종료하려고 합니다. 계속하기 전에 프로필을 저장하시겠습니까?',
            stayAction: '이 페이지에 머무르기',
            saveAction: '프로필 저장',
            continueAction: '저장하지 않고 계속',
        },
    },
    tests: {
        header: '테스트',
        unauthorized:
            '테스트는 현재 클로즈 베타입니다. 아직 이러한 기능에 액세스할 수 없습니다. 곧 이용할 수 있을 거예요!',
        error: '테스트를 로드하려고 할 때 문제가 발생했습니다. 나중에 다시 시도해 주십시오.',
        assessmentModule: { header: '당신의 평가' },
        completedYourProfile: '이 평가에 액세스하려면 프로필을 완료해야 합니다.',
        toMyProfile: '내 프로필 편집',
    },
    vfair: {
        header: 'EFMD 가상 이벤트',
        activeNow: '진행 중',
        visibilityPrivate: '개인',
        visibilityNetwork: '네트워크',
        visibilityOpen: '열림',
        interested: '등록',
        attend: '이벤트 참석',
        enterEvent: '가상 이벤트 입력',
        notinterested: '더 이상 관심이 없습니다',
        shownInterest: '등록됨',
        signUpToday: '오늘 가입하세요!',
        vfairsInfo:
            '채용자와 지원자 간의 실시간 상호작용이 가능한 정교한 채용 박람회 시뮬레이션 환경에서 전 세계 기업 및 조직과 연결되어보세요. 관심 있는 가상 이벤트를 클릭하고 등록하면 알림을 받을 수 있습니다.',
        recruitingOrgs: '기업 & 조직 모집',
        preRegistered: '사전 등록됨',
        prepareForTheFair: '가상 이벤트 준비',
        privateVFairHeader: '캠퍼스 가상 이벤트',
        privateVFairMessage:
            '이 가상 이벤트는 EFMD 학교 플랫폼에서 호스트되므로 여기에서 액세스할 수 없습니다.',
        schoolNotJoinedNetworkEventMessage:
            '귀하의 학교는 아직 이 가상 이벤트에 등록하지 않았습니다. 프로그램 책임자나 경력 부서에 연락하여 참여를 요청하십시오.',
        companyNotJoinedNetworkEventMessage:
            '이 이벤트에는 조직에서 사용할 수 있는 가상 부스가 없습니다. Highered에 연락하여 참여를 요청하십시오.',
        pavilions: '파빌리온스',
        general: '일반',
        allCompanies: '모든 회사',
        lobby: '로비',
        inviteCode: '초대 코드',
        eventRequiresInvitation: '해당 이벤트는 초대장을 요합니다',
        haveCode: '저는 코드가 있습니다.',
        checkCode: '코드 확인하기',
        invalidCode: '잘못된 코드',
        registeredSuccessfully: '성공적으로 등록됨',
        pavilionTabs: {
            home: '홈',
            companies: '회사',
            articles: '기사',
            jobs: '채용 공고',
            events: '이벤트',
        },
        events: {
            noEventsAvailable: '이용 가능한 이벤트 없음',
            showCompleted: '표시 완료',
            hideCompleted: '숨기기 완료',
            liveNow: '지금 라이브',
            joinTheEvent: '이벤트에 참여하십시오.',
            addToCalendar: '일정관리에 추가',
        },
        links: {
            masterclasses: {
                header: '마스터 클래스',
                buttonCaption: '마스터 클래스 보기',
                description:
                    '한 번 더 보게 만드는 CV 최적화, "당신의 Linkedin 프로필을 멋지게 만들어봐요" 및 "연봉 협상"을 비롯한 다양한 최고 품질의 마스터 클래스를 살펴보십시오',
            },
            detailsmasterclass: { header: '마스터 클래스 참석' },
            cv: {
                header: 'CV 템플릿',
                buttonCaption: 'CV 템플릿 다운로드',
                description:
                    'Highered ATS 친화적인 CV 템플릿에 액세스하여 채용 담당자에게 전문적인 인상을 심어줘보세요.',
            },
            elevatorPitch: {
                header: '엘리베이터 피치 챌린지',
                buttonCaption: '당신의 피치 보내기',
                description:
                    '피치 퍼펙트 챌린지를 경험해 보십시오! 글로벌 최고의 기업 및 조직의 수백 명의 채용 담당자들에게 귀사의 가치를 알릴 수 있는 기회입니다!',
            },
        },
        footerHeaders: {
            social: '자세한 최신 뉴스를 알아보려면 저희를 팔로잉해주세요',
            sponsored: '후원자:',
            organized: '구성자:',
        },
        educationPopup: {
            step00: {
                header: '당신의 교육 내용 공유',
                subtitle: '계속하려면 고용주들에게 당신에 대해 더 많이 알려주세요.',
                continueLabel: '내 교육 추가',
                leaveLabel: '무시하기',
            },
            step01: { header: '당신의 교육에 대해 알려주세요.' },
            step02: { loadingLabel: '잠깐만요...' },
            step03: {
                header: '완료된 교육',
                subtitle:
                    '당신은 이제 프로필을 공유하고 고용주들 사이에서 더 흥미로운 후보자가 될 수 있습니다.',
                continueLabel: '가상 이벤트 탐색 계속',
            },
            error: {
                header: '맙소사! 오류가 발생했습니다!',
                subtitle:
                    '우리는 당신의 교육 정보를 저장할 수 없었습니다. 나중에 다시 시도해 주십시오.',
            },
        },
    },
};
